import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { ModalWindow } from '@cian/ui-kit';
import * as React from 'react';
import { OtherServicesItem, OtherServicesLayout } from '../../components/OtherServices';
import { useServicesBlockProps, useServicesModalProps, useTrackClicks, useTrackServicesShow } from './hooks';
import { VIEWED_TIMEOUT } from '../../constants/viewedBlock';
import { IUseTrackServiceClickProps, trackClickServiceItem, TServiceEventLabel } from './utils';
import { mapPageTypeToAnalytics } from '../../utils/getPageviewObject';
import { useSelector } from 'react-redux';
import { selectPageType } from '../../selectors/page';

export const OtherServicesContainer: React.FC = () => {
  const pageType = useSelector(selectPageType);

  const { testId, headingTitle, items, showAllServicesButton, withoutBorder } = useServicesBlockProps();
  const { modalTitle, otherItems, isModalOpen, onModalClose, onModalOpen } = useServicesModalProps(items);

  const { trackGoToAddFormLinkClick } = useTrackClicks();
  const trackServicesShow = useTrackServicesShow(items);
  const trackServiceClick = ({ label, place }: IUseTrackServiceClickProps) => {
    trackClickServiceItem({
      pageType: mapPageTypeToAnalytics[pageType],
      label,
      place,
    });
  };

  return (
    <>
      <ActionAfterViewObserver callback={trackServicesShow} callbackDelay={VIEWED_TIMEOUT}>
        <OtherServicesLayout
          testId={testId}
          heading={headingTitle}
          showButton={showAllServicesButton}
          onLinkClick={trackGoToAddFormLinkClick}
          onButtonClick={onModalOpen}
        >
          {items.map(({ title, description, icon, link, eventLabel }, index) => (
            // Выводим три рандомных сервиса
            <OtherServicesItem
              key={title + index}
              title={title}
              description={description}
              icon={icon}
              link={link}
              withoutBorder={withoutBorder}
              onClick={() => trackServiceClick({ label: eventLabel as TServiceEventLabel, place: 'page' })}
            />
          ))}
        </OtherServicesLayout>
      </ActionAfterViewObserver>

      <ModalWindow
        title={modalTitle}
        open={isModalOpen}
        onClose={onModalClose}
        fixed
        content={
          <>
            {otherItems.map(({ title, description, icon, link, eventLabel }, index) => (
              // Выводим оставшиеся сервисы в начале списка
              <OtherServicesItem
                key={title + index}
                title={title}
                description={description}
                icon={icon}
                link={link}
                onClick={() => trackServiceClick({ label: eventLabel as TServiceEventLabel, place: 'modal' })}
              />
            ))}
            {items.map(({ title, description, icon, link, eventLabel }, index) => (
              // Выводим три рандомных сервиса в конце списка
              <OtherServicesItem
                key={title + index}
                title={title}
                description={description}
                icon={icon}
                link={link}
                onClick={() => trackServiceClick({ label: eventLabel as TServiceEventLabel, place: 'modal' })}
                withoutBorder
              />
            ))}
          </>
        }
      />
    </>
  );
};
